<template>
  <div class="attr-list">
    <el-form>
      <el-form-item label="背景颜色">
        <el-color-picker v-model="curComponent.style.background" show-alpha />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

export default {
  components: { },
  computed: {
    curComponent() {
      return this.$store.state.compose.curComponent
    }
  }
}
</script>
